/**
 * Created by Макс on 01.11.2017.
 */
/**
 * Created by Макс on 01.11.2017.
 */
import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'dealer-menu-main-comp',
    templateUrl: 'menu-main/index.html',
    styleUrls: ['add-access/bootstrap.min.css','add-access/update.css','add-access/style.css'], //left-menu/style.min.css
})
export class DealerMenuMainComponent {
    constructor(
        private broadcaster: Broadcaster,
        private elRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-menu-main.component.ts